import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Store } from '@ngxs/store';
import { CheckoutPaymentInformationState } from '@platform-frontend/checkout';
import { ScaReason } from '@platform-frontend/marketplace';
import { InvalidStateError } from '@platform-frontend/util';

@Injectable({
  providedIn: 'root'
})
export class ScaUrlService {
  constructor(private store: Store) {}

  getSuccessUrl(reason: ScaReason): { url: string; queryParams?: Params } {
    switch (reason) {
      case 'purchase':
      case 'renew':
        return { url: '../confirmation', queryParams: { reason } };
      case 'creation':
        return { url: this.getProceedUrl(1), queryParams: undefined };
      case 'selection':
        return { url: '../payment-method-selection', queryParams: undefined };
      default:
        throw new InvalidStateError('Could not get reason');
    }
  }

  getFailureUrl(reason: ScaReason): string {
    switch (reason) {
      case 'purchase':
      case 'renew':
        return '../overview';
      case 'creation':
        return this.getProceedUrl(0);
      case 'selection':
        return '../payment-method-selection';
      default:
        throw new InvalidStateError('Could not get reason');
    }
  }

  private getProceedUrl(upperBound: number): string {
    const paymentMethodCount = this.store.selectSnapshot(CheckoutPaymentInformationState.paymentMethods).length;
    if (paymentMethodCount <= upperBound) {
      return '../overview';
    } else {
      return '../payment-method-selection';
    }
  }
}
